export const USER_LOGIN = "feature/Auth/USER_LOGIN";
export const USER_LOGOUT = "feature/Auth/USER_LOGOUT";
